import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/home/home.vue'),
        meta: {
          headerBg: '#F6DDC4',
          headerText: '#000000',
          btnBg: '#b24e1a',
            btnText: '#ffffff',
            btnHoverBg: '#ffffff',
            btnTextHover: '#b24e1a'
        }
      },
      {
        path: '/website',
        name: 'website',
        component: () => import('@/views/website/website.vue'),
        meta: {
          headerBg: '#E39A4D',
          headerText: '#000000',
            btnBg: '#d97706',
            btnText: '#7c2d12',
            btnHoverBg: '#ffedd5',
            btnTextHover: '#7c2d12'
        }
      },
      {
        path: '/email',
        name: 'email',
        component: () => import('@/views/email/email.vue'),
        meta: {
          headerBg: '#CBB0EB',
          headerText: '#000000',
          btnBg: '#8b5cf6',
              btnText: '#4c1d95',
              btnHoverBg: '#E5D7F5',
              btnTextHover: '#4c1d95'
        }
      },
      {
        path: '/switch',
        name: 'switch',
        component: () => import('@/views/switch/switch.vue'),
        meta: {
          headerBg: '#F6DDC4',
          headerText: '#000000',
            btnBg: '#ea580c',
            btnText: '#7c2d12',
            btnTextHover: '#7c2d12'
        }
      },
      {
        path: '/pricing',
        name: 'pricing',
        component: () => import('@/views/pricing/pricing.vue'),
        meta: {
          headerBg: '#E5D7F5',
          headerText: '#000000',
          btnBg: '#7c3aed',
              btnText: '#4c1d95',
              btnTextHover: '#4c1d95'
        }
      },
       {
        path: '/online-store',
        name: 'onlineStore',
        component: () => import('@/views/store/online-store/index.vue'),
        meta: {
          headerBg: '#A5C8D8',
          headerText: '#000000',
            btnBg: '#0284c7',
            btnText: '#075985',
            btnTextHover: '#075985'
        }
      },
       {
        path: '/online-courses',
        name: 'onlineCourses',
        component: () => import('@/views/store/online-courses/index.vue'),
          meta: {
          headerBg: '#E1EDF2',
          headerText: '#000000',
           btnBg: '#0d9488',
            btnText: '#115e59',
            btnTextHover: '#115e59'
          }
      },
      {
        path: '/digital-downloads',
        name: 'digitalDownloads',
        component: () => import('@/views/store/digital-downloads/index.vue'),
        meta: {
          headerBg: '#E1EDF2',
          headerText: '#000000',
           btnBg: '#ca8a04',
            btnText: '#713f12',
            btnTextHover: '#713f12'
          }
      },
      {
        path: '/webinars',
        name: 'webinars',
        component: () => import('@/views/store/webinars/index.vue'),
        meta: {
          headerBg: '#E1EDF2',
          headerText: '#000000',
           btnBg: '#db2777',
            btnText: '#831843',
            btnTextHover: '#831843'
          }
      },
      {
        path: '/coaching',
        name: 'coaching',
        component: () => import('@/views/store/coaching/index.vue'),
        meta: {
          headerBg: '#E1EDF2',
          headerText: '#000000',
           btnBg: '#0891b2',
            btnText: '#164e63',
            btnTextHover: '#164e63'
          }
      },
      {
        path: '/community',
        name: 'community',
        component: () => import('@/views/store/community/index.vue'),
        meta: {
          headerBg: '#E1EDF2',
          headerText: '#000000',
           btnBg: '#16a34a',
            btnText: '#166534',
            btnTextHover: '#166534'
          }
      }
    ]
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/views/signup/index.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/terms/index.vue'),
  },
  {
    path: '/col-cashier',
    name: 'colCashier',
    component: () => import('@/views/colombia-cashier/index.vue'),
  }
]


const router = new VueRouter({
  routes,
})

router.afterEach((to, from) => {
  document.body.dataset.page = to.name || 'home';
  window.scrollTo(0, 0);
});


export default router
